module.exports = __webpack_public_path__ + "static/media/red-timer.d25f20cd.png";